import debounce from "lodash/debounce";
import { Value } from "react-powerplug";
import { IOrderDirection } from "types/graphqlTypes";
import { ArrowDown10Icon, ArrowUp01Icon } from "lucide-react";
import React from "react";
import { useIntl } from "react-intl";

interface EventsCalendarSearchBarProps {
  searchQuery: string | null;
  orderBy: IOrderDirection;
  setSearchQuery: (value: string | null) => void;
  setOrderBy: (value: IOrderDirection) => void;
}

export default function EventsCalendarSearchBar({
  searchQuery,
  orderBy,
  setSearchQuery,
  setOrderBy,
}: EventsCalendarSearchBarProps) {
  const intl = useIntl();

  return (
    <div className="flex items-center space-x-4">
      <Value
        initial={searchQuery}
        onChange={debounce((searchQuery) => {
          const safeSearchQuery = searchQuery.trim();

          setSearchQuery(safeSearchQuery);
        }, 400)}
      >
        {({ value, set }) => (
          <input
            type="text"
            className="flex w-full rounded-md border-gray-300 shadow-sm placeholder:tracking-wide placeholder:text-gray-400 focus:border-indigo-500 focus:ring-indigo-500 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-300 dark:placeholder:text-slate-400 dark:focus:border-indigo-400 dark:focus:ring-indigo-400"
            value={value || ""}
            onChange={(event) => set(event.target.value)}
            placeholder={intl.formatMessage({
              defaultMessage: "Pesquise ativos pelo código de negociação...",
              id: "294TQS",
              description: "Agenda",
            })}
          />
        )}
      </Value>

      <button
        className="h-6 w-6 text-gray-400 hover:cursor-pointer hover:text-indigo-500 dark:text-slate-500 dark:hover:text-indigo-400"
        type="button"
        onClick={() => {
          setOrderBy(orderBy === IOrderDirection.Ascending ? IOrderDirection.Descending : IOrderDirection.Ascending);
        }}
      >
        {orderBy === IOrderDirection.Ascending ? (
          <ArrowUp01Icon strokeWidth={1.5} className="h-6 w-6" />
        ) : (
          <ArrowDown10Icon strokeWidth={1.5} className="h-6 w-6" />
        )}
      </button>
    </div>
  );
}
